import script from "./ChartDataEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChartDataEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ChartDataEditor.vue?vue&type=style&index=0&id=1eab5a3a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eab5a3a"]])

export default __exports__